
<div class="pa-0" v-if="liftmanager">
    <c-drawer-header
        v-resize   = "onResize"
        title      = "Clipboard"
        :subtitle  = "customer ? customer.name : null"
        icon       = "fas fa-inbox"
        :usefilter = "true"
        :usetoggle = true
        @close     = "onClose"
        @filter    = "onFilter"
        @toggle    = "onToggle"
        @arrow     = "onArrow"
    />
    <v-expand-transition>
        <div v-if="filter" class="filter-panel">
            <div class="mt-3 mb-3">
                <v-text-field
                    v-model        = "searchtext"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    append-icon    = "fas fa-search"
                    clearable
                    hide-details
                />
            </div>
        </div>
    </v-expand-transition>

    <div>
        <v-layout row wrap class="ml-3 mt-0 mr-1" :style="'height: ' + height + 'px'">
            <div v-if="!entries || entries.length === 0" class="inb-no-messages">
                Clipboard hat keine Einträge
            </div>
            <v-container v-if="entries && entries.length > 0" fluid class="h-100 pa-0" style="width: calc(100% + 10px)">
                <v-data-iterator
                    :items         = "entries"
                    :search        = "searchtext"
                    :custom-filter = "cfilter"
                    hide-default-footer
                    :items-per-page="100"
                    style="overflow-x: hidden; overflow-y: scroll; max-height: calc(100% - 1px)"
                >
                    <template v-slot:default="props">
                        <c-inc-clipboard-entry
                            v-for="(item) in props.items"
                            :key   = "item.id"
                            :entry = "item"
                            class="mt-3 pr-2 pl-1"
                            @dragend = "onDragend"
                        />
                    </template>
                </v-data-iterator>
            </v-container>
        </v-layout>
    </div>
</div>
